import React, { useEffect, useRef } from "react";
import axios from "axios";
import { API_URL_POST_E_LEARNING_PLAYER_TOKEN } from "src/common/constants";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Alert } from "reactstrap";
import "./Style.css";

const Player = ({
    token,
    t,
    data: {
        video_address: srcUrl,
        lesson_name,
        lesson_id
    }
}) => {
    const iframeRef = useRef(null);

    const {
        data: itemHtmlContent,
        isFetching: fetchingContent,
        refetch: fetchHtmlContent
    } = useQuery({
        queryKey: [
            "fetch-e-learning-details-html-content-query",
            lesson_id,
            srcUrl
        ],
        queryFn: async () => {
            const response = await axios.get(
                srcUrl
            );

            return response.data || null;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: false,
        onError: () => {
            toast(t("An error occurred while fetching the E-Learning details."), {
                type: "error"
            });
        }
    });

    useEffect(() => {
        if(itemHtmlContent){
            const iframeDocument =
                iframeRef.current.contentDocument ||
                iframeRef.current.contentWindow.document;

            if (iframeDocument) {
                iframeRef.current.removeEventListener("load", fetchHtmlContent);

                const convertToAbsoluteUrls = (html, baseUrl) => {
                    const doc = new DOMParser().parseFromString(html, "text/html");

                    const base = doc.createElement("base");
                    base.href = baseUrl;
                    doc.head.insertBefore(base, doc.head.firstChild);

                    doc.querySelectorAll("a").forEach((anchor) => {
                        const href = anchor.getAttribute("href");
                        if (href && !href.startsWith("http") && !href.startsWith("//")) {
                            anchor.href = new URL(href, baseUrl).href;
                        }
                    });

                    doc.querySelectorAll("img, script, link").forEach((tag) => {
                        const src = tag.getAttribute("src") || tag.getAttribute("href");
                        if (src && !src.startsWith("http") && !src.startsWith("//")) {
                            if (tag.hasAttribute("src")) {
                                tag.src = new URL(src, baseUrl).href;
                            } else {
                                tag.href = new URL(src, baseUrl).href;
                            }
                        }
                    });

                    return doc.documentElement.outerHTML;
                };

                const baseUrl = new URL(srcUrl).href;
                const absoluteHtmlContent = convertToAbsoluteUrls(
                    itemHtmlContent,
                    baseUrl
                );

                iframeDocument.open();
                iframeDocument.write(absoluteHtmlContent);
                iframeDocument.close();

                // Inject custom styles
                const styleElement = iframeDocument.createElement('style');
                styleElement.textContent = `
                    .choice-view__choice-container {
                        width: auto !important;
                        height: auto !important;
                    }
                `;
                iframeDocument.head.appendChild(styleElement);

                const loadScripts = (scripts, index = 0) => {
                    if (index >= scripts.length) return;

                    const oldScript = scripts[index];
                    const newScript = iframeDocument.createElement("script");

                    if (oldScript.src) {
                        newScript.src = oldScript.src;
                        newScript.type = oldScript.type || "text/javascript";
                        newScript.async = oldScript.async || false;
                        newScript.defer = oldScript.defer || false;
                        newScript.crossOrigin = oldScript.crossOrigin || null;

                        if (oldScript.integrity) {
                            newScript.integrity = oldScript.integrity;
                        }

                        newScript.onload = () => loadScripts(scripts, index + 1);
                        newScript.onerror = () =>
                            console.error(`Failed to load script: ${newScript.src}`);
                        iframeDocument.body?.appendChild(newScript);
                    } else {
                        newScript.textContent = oldScript.textContent;
                        iframeDocument.body?.appendChild(newScript);
                        loadScripts(scripts, index + 1);
                    }
                };

                const scripts = iframeDocument.querySelectorAll("script");
                loadScripts(scripts);
            }
        }
    }, [
        itemHtmlContent
    ]);

    const searchLocalStorage = (substring) => {
        const result = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.includes(substring)) {
                const value = localStorage.getItem(key);
                result.push({ key, value });
            }
        }
        return result;
    };

    useEffect(() => {
        const iframe = iframeRef.current;

        if (iframe) {
            if (
                iframe.contentDocument &&
                iframe.contentDocument.readyState === "complete"
            ) {
                fetchHtmlContent();
            } 
            else {
                iframe.addEventListener("load", fetchHtmlContent);
                return () => {
                    iframe.removeEventListener("load", fetchHtmlContent);
                };
            }
        }

        // Cleanup function to log a message when the component unmounts
        return () => {
            (async () => {
                const url = API_URL_POST_E_LEARNING_PLAYER_TOKEN;
                const results = searchLocalStorage("ispring");
                const data = {
                    lesson_id: lesson_id,
                    token_key: results[0]?.key,
                    token_value: results[0]?.value,
                };
                const header = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };

                try {
                    await axios.post(url, data, header);
                } catch (err) {
                    console.log("Error in the system", err);
                }
            })();
        };
    }, [srcUrl]);

    return (
        <div className="playerContainer">
            {fetchingContent && (
                <Alert
                    color="info"
                >
                    {t('Loading')}...
                </Alert>
            )}
            <iframe
                title={`${lesson_name}-${lesson_id}`}
                ref={iframeRef}
                className="player"
            />
            <style>
                {`.choice-view__choice-container {
                    background-color: red !important;
                    padding: 20px;
                    bosrcUrlrder: 1px solid #ccc;
                }`}
            </style>
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return { token };
};

export default withNamespaces()(
    withRouter(
        connect(mapStatetoProps)(
            Player
        )
    )
);
